import { useContext, useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../routing/LangRouter";

//import utils
import { convertToJalali } from "../../../utils/date";

//import general components
import BaseTable from "../../common/base-table/base-table";

//import images and icons
import { Profile2User } from "iconsax-react";

//import styles
import "./confirm.scss";

function PassengersInformation({ title, information, type }) {
    //general variables
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();
    const hotelInformation = JSON.parse(sessionStorage.getItem("hotelInformation"));

    const ageType = {
        adt: t("adult"),
        chd: t("child"),
        inf: t("infant"),
        ADL: t("adult"),
        CHD: t("child"),
        INF: t("infant"),
    };

    //table's columns
    const flightColumns = useMemo(() => [
        {
            accessorKey: "name",
            header: `${t("firstName")} ${locale === "en" ? "and" : "و"} ${t("lastName")}`,
            size: 200,
            enableSorting: false,
        },
        {
            accessorKey: "gender",
            header: `${t("gender")}`,
            enableSorting: false,
        },
        {
            accessorKey: "code",
            header: `${t("nationalCode")} / ${t("passport")}`,
            enableSorting: false,
        },
        {
            accessorKey: "birthday",
            header: `${t("birthday")}`,
            enableSorting: false,
        },
        {
            accessorKey: "nationality",
            header: `${t("nationality")}`,
            enableSorting: false,
        },
        {
            accessorKey: "ages",
            header: `${t("ageGroup")}`,
            enableSorting: false,
        },
    ]);
    const busColumns = useMemo(() => [
        {
            accessorKey: "name",
            header: `${t("firstName")} ${locale === "en" ? "and" : "و"} ${t("lastName")}`,
            size: 200,
            enableSorting: false,
        },
        {
            accessorKey: "gender",
            header: `${t("gender")}`,
            enableSorting: false,
        },
        {
            accessorKey: "code",
            header: `${t("nationalCode")} / ${t("passport")}`,
            enableSorting: false,
        },
        {
            accessorKey: "birthday",
            header: `${t("birthday")}`,
            enableSorting: false,
        },
        {
            accessorKey: "phoneNumber",
            header: `${t("phoneNumber")}`,
            enableSorting: false,
        },
        {
            accessorKey: "seatNumber",
            header: `${t("seatNumber")}`,
            enableSorting: false,
        },
    ]);

    const hotelColumns = useMemo(() => [
        {
            accessorKey: "name",
            header: `${t("firstName")} ${locale === "en" ? "and" : "و"} ${t("lastName")}`,
            size: 200,
            enableSorting: false,
        },
        {
            accessorKey: "code",
            header: `${t("nationalCode")} / ${t("passport")}`,
            enableSorting: false,
        },
        {
            accessorKey: "nationality",
            header: `${t("nationality")}`,
            enableSorting: false,
        },
    ]);

    const intHotelColumns = useMemo(() => [
        {
            accessorKey: "name",
            header: `${t("firstName")} ${locale === "en" ? "and" : "و"} ${t("lastName")}`,
            size: 200,
            enableSorting: false,
        },
        {
            accessorKey: "gender",
            header: `${t("gender")}`,
            enableSorting: false,
        },
        {
            accessorKey: "code",
            header: `${t("nationalCode")} / ${t("passport")}`,
            enableSorting: false,
        },
        {
            accessorKey: "nationality",
            header: `${t("nationality")}`,
            enableSorting: false,
        },
        {
            accessorKey: "ages",
            header: type !== "hotel" ? `${t("ageGroup")}` : "",
            enableSorting: false,
        },
    ]);

    //table's rows
    const [passengerRows, setPassengerRows] = useState([]);
    useEffect(() => {
        if (information?.passengers) {
            setPassengerRows(mapPassengersToTableRows(information.passengers));
        }
    }, [information]);

    const mapPassengersToTableRows = passengers => {
        return passengers?.map(passenger => ({
            name: renderPassengerName(passenger),
            gender: locale === "en" ? passenger?.gender?.english_name : passenger?.gender?.name,
            phoneNumber: passenger.phone_number,
            code: getPassengerCode(passenger),
            nationality:
                passenger.nationality?.name || passenger.nationality?.name || passenger.national_id?.name || hotelInformation?.nationality?.name,
            birthday: locale === "en" ? passenger?.birthdate : convertToJalali(passenger?.birthdate),
            ages: ageType?.[passenger.type] || ageType?.[passenger.passenger_type],
            seatNumber: passenger.seatNumber,
        }));
    };

    const renderPassengerName = passenger => (
        <Grid container item xs="auto" direction="column">
            <span>
                {passenger.first_name} {passenger.last_name}
            </span>
            <span className="confirm__english-name">
                {passenger.english_first_name} {passenger.english_last_name}
            </span>
        </Grid>
    );

    const getPassengerCode = passenger => {
        const { national_code, national_id, passport_no } = passenger;
        const primaryId = national_code || national_id || "";
        const passportNum = passport_no || "";

        return primaryId && passportNum ? `${primaryId} / ${passportNum}` : primaryId || passportNum;
    };

    return (
        <Grid container item xs={12} justifyContent="center">
            <Grid className="confirm__title" container item xs={6} justifyContent="center">
                <Profile2User color="var(--light-color)" variant="Bold" /> {title}
            </Grid>
            <Grid className="confirm" container item xs={12} justifyContent="space-between" alignItems="flex-start">
                <BaseTable
                    columns={type === "intHotel" ? intHotelColumns : type === "hotel" ? hotelColumns : type === "bus" ? busColumns : flightColumns}
                    rows={passengerRows}
                    details={false}
                    action={false}
                    rowBackground="var(--white-gray-color)"
                />
            </Grid>
        </Grid>
    );
}

export default PassengersInformation;
